/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon24Solid = forwardRef('ArrowDCornerLeftUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M1.69 8.44a1.5 1.5 0 0 0 2.12 2.12L8 6.372V16.5a4.5 4.5 0 0 0 4.5 4.5h9a1.5 1.5 0 1 0 0-3h-9a1.5 1.5 0 0 1-1.5-1.5V6.37l4.19 4.19a1.5 1.5 0 0 0 2.12-2.122l-5.503-5.503a3.263 3.263 0 0 0-4.614 0L1.689 8.439Z" })));
});
